import { render, staticRenderFns } from "./deliverCode.vue?vue&type=template&id=2db64e6f&scoped=true&"
import script from "./deliverCode.vue?vue&type=script&lang=js&"
export * from "./deliverCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db64e6f",
  null
  
)

export default component.exports